import React from 'react';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles({
    root: {
        background: 'rgba(255, 255, 255, 0.15)', // Glassy background
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)', // Subtle shadow
        borderRadius: '12px', // Rounded corners
        backdropFilter: 'blur(10px)', // Blur effect
        color: '#fff', // White text
        marginBottom: '20px',
    },
    title: {
        fontSize: '1.2rem',
        fontWeight: 'bold',
        marginBottom: '10px',
        color: '#ce1f1f', // Red title
    },
    item: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '5px',
    },
    total: {
        fontWeight: 'bold',
    },
});

function SubscriptionSummary() {
    const classes = useStyles();

    return (
        <Card className={classes.root}>
            <CardContent>
                <Typography variant="h6" className={classes.title}>
                    Supreme/Nike Bot Life-Time Access
                </Typography>
                <div className={classes.item}>
                    <Typography>Price</Typography>
                    <Typography>$10</Typography>
                </div>
                <Typography variant="body2" color="light-gray">
                    One-time payment
                </Typography>
                {/* ... other items ... */}
                <div className={classes.item}>
                    <Typography variant="subtitle1" className={classes.total}>
                        Total due today
                    </Typography>
                    <Typography variant="subtitle1" className={classes.total}>
                        $10
                    </Typography>
                </div>
            </CardContent>
        </Card>
    );
}

export default SubscriptionSummary;